import { RESET_FILTER, UPDATE_FILTER } from "../action/filter.action";
import { nextSurveyMarks, lastDockingMarks, ageMarks } from '../../react/components/utils'
import { updateMapProperty } from "../action/map-data.action";

const initialState = {
  minVesselLength: "",
  maxVesselLength: "",
  minVesselWidth: "",
  maxVesselWidth: "",
  nextSurvey: "",
  nextSurveyMarkValue: 3,
  selectAllVesselTypes: true,
  scrubber: "",
  actualVesselPosition: true,
  colorFor: "nextSurvey",
  age: "",
  minAge: "",
  maxAge: "",
  ageMarkArray: [0, 5],
  heatmapMonths: 6,
  shipmanagerCountryId: "",
  selectedVesselTypes: ["general_cargo_ship", "specialized_cargo_ship", "container_ship", "ro_ro_cargo_ship", "bulk_carrier", "oil_and_chemical_tanker", "gas_tanker", "other_tanker", "passenger_ship", "offshore_vessel", "service_ship", "tug", "fishing_vessel", "pleasure_craft", "other"],
  selectAllContinents: true,
  selectedContinents: ["EU", "AF", "NA", "SA", "AS", "OC"],
  unSelectedContinents: [],
  selectAllSailingareas: true,
  selectedSailingareas: ["1319", "1309", "1313", "1331", "1336", "1318", "1310", "1332", "1312", "1329", "1330", "1316", "1321", "1328", "1326", "1315", "1314", "1337", "1322", "1320", "1327", "1317", "1325", "1324", "1311"],
  unSelectedSailingareas: [],
  blockAllSailingareas: false,
  blockedSailingareas: [],
  engineId: "",
  engineName: "",
  portId: "",
  portName: "",
  engineBuilderId: "",
  visitedShipyardId: "",
  visitedShipyardName: "",
  lastDocking: "",
  lastDockingMarkValue: 6,
  vesselLengthArray: [10, 400],
  vesselWidthArray: [10, 70],
  filterSerial: 0,
  deficiencyArea: "",
  keyword: "",
};

export default function filterReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_FILTER:
      Object.assign(state,
        {
          minVesselLength: "",
          maxVesselLength: "",
          minVesselWidth: "",
          maxVesselWidth: "",
          nextSurvey: "",
          nextSurveyMarkValue: 3,
          selectAllVesselTypes: true,
          scrubber: "",
          actualVesselPosition: true,
          colorFor: "nextSurvey",
          age: "",
          minAge: "",
          maxAge: "",
          ageMarkArray: [0, 5],
          heatmapMonths: 6,
          shipmanagerCountryId: "",
          selectedVesselTypes: ["general_cargo_ship", "specialized_cargo_ship", "container_ship", "ro_ro_cargo_ship", "bulk_carrier", "oil_and_chemical_tanker", "gas_tanker", "other_tanker", "passenger_ship", "offshore_vessel", "service_ship", "tug", "fishing_vessel", "pleasure_craft", "other"],
          selectAllContinents: true,
          selectedContinents: ["EU", "AF", "NA", "SA", "AS", "OC"],
          unSelectedContinents: [],
          selectAllSailingareas: true,
          selectedSailingareas: ["1319", "1309", "1313", "1331", "1336", "1318", "1310", "1332", "1312", "1329", "1330", "1316", "1321", "1328", "1326", "1315", "1314", "1337", "1322", "1320", "1327", "1317", "1325", "1324", "1311"],
          unSelectedSailingareas: [],
          blockAllSailingareas: false,
          blockedSailingareas: [],
          engineId: "",
          engineName: "",
          portId: "",
          portName: "",
          engineBuilderId: "",
          visitedShipyardId: "",
          visitedShipyardName: "",
          lastDocking: "",
          lastDockingMarkValue: 6,
          vesselLengthArray: [10, 400],
          vesselWidthArray: [10, 70],
        });

      return {
        ...state,
        filterSerial: (state.filterSerial + 1)
      }

    case UPDATE_FILTER:
      Object.assign(state, action.payload)
      let parameters = action.payload
      if (parameters.nextSurvey) {
        state.nextSurvey = parameters.nextSurvey
        state.nextSurveyMarkValue = nextSurveyMarks.valueToMark[parameters.nextSurvey]
      }
      if (parameters.lastDocking) {
        state.lastDocking = parameters.lastDocking
        state.lastDockingMarkValue = lastDockingMarks.valueToMark[parameters.lastDocking]
      }

      if (parameters.engineId) {
        state.engineId = parameters.engineId
        state.engineName = parameters.engineName
      }
      if (parameters.keyword) {
        state.keyword = parameters.keyword
      }

      return {
        ...state,
        filterSerial: (state.filterSerial + 1)
      }
    default:
      return state;
  }
}